/*
 * -----------------------------------------------------------------------
 *  <copyright file="sites.ts" company="Triumph Research Intelligence">
 *      Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import { gql } from '@apollo/client';
import {
    SiteFragment
} from './fragments';

export const GET_SITES = gql`
    query getSites($studyId: ObjectId!, $timestamp: DateTime) {
        sites(studyId: $studyId, timestamp: $timestamp) {
            ...SiteFields
        }
    }
    ${SiteFragment}
`;

export const GET_ALL_SITES = gql`
    query getAllSites($studyId: ObjectId!, $timestamp: DateTime) {
        allSites(studyId: $studyId, timestamp: $timestamp) {
            ...SiteFields
        }
    }
    ${SiteFragment}
`;

export const GET_SITE = gql`
    query getSite($id: ObjectId!, $timestamp: DateTime) {
        site(id: $id, timestamp: $timestamp) {
            ...SiteFields
        }
    }
    ${SiteFragment}
`;

export const GET_SITES_DELETE = gql`
    query getSitesDelete($studyId: ObjectId!, $timestamp: DateTime) {
        sitesDelete(studyId: $studyId, timestamp: $timestamp) {
            ...SiteFields
        }
    }
    ${SiteFragment}
`;

export const GET_SITE_SUMMARY_OVERVIEW_TABLE = gql`
    query siteOverviewTable($currentDataSetId: ObjectId!, $previousDataSetId: ObjectId!, $studyId: ObjectId!) {
        siteOverviewTable(currentDataSetId: $currentDataSetId, previousDataSetId: $previousDataSetId, studyId: $studyId){
            siteName
            panelColumnOrder
            columnSummary {
                title
                current
                previous
                change
                columnOrder
                type
            }
            panelSummary {
                panelName
                plotTile
                panelOrder
                values {
                    title
                    current
                    previous
                    change
                    type
                }
            }
        }
    }
`;
